import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql-client";
import { graphql, ResultOf } from "@/graphql";
export const TelemetryQuery = graphql(`
  query getTelemetryInfo {
    company {
      id
      email
      name
      accountStatus
      subscription {
        planPriceId
        status
        plan {
          name
        }
        tier {
          name
          level
        }
      }
    }
    user {
      id
      firstName
      lastName
      email
      role
    }
  }
`);
export type TelemetryInfo = ResultOf<typeof TelemetryQuery>;
export function useTelemetryInfo(t0) {
  const $ = _c(5);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    enabled: t2
  } = t1;
  const enabled = t2 === undefined ? true : t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["telemetryInfo"];
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== enabled) {
    t4 = {
      queryKey: t3,
      queryFn: _temp2,
      enabled
    };
    $[3] = enabled;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return useQuery(t4);
}
function _temp2() {
  return graphqlClient.request(TelemetryQuery).then(_temp);
}
function _temp(res) {
  return res;
}